import styled from "styled-components";

export const Container = styled.div`
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3px 6px #dcdcdc;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const Title = styled.span`
  font-family: Asap;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  color: #4b4b4b;
  text-transform: uppercase;
  svg {
    margin-left: 5px;
  }
`;
